var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSatisfied(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.1997 5.0332C26.2366 5.07008 26.3121 5.16669 26.3921 5.37988C26.4729 5.59546 26.5004 5.76632 26.5005 5.89941V6.32715L24.7046 13.4268L24.311 14.9834H35.0005C35.5361 14.9835 36.0018 15.1693 36.4497 15.6172C36.8976 16.0652 37.0835 16.5308 37.0835 17.0664V20.3994C37.0835 20.5052 37.0721 20.6359 37.0425 20.7939C37.0165 20.9323 36.979 21.0525 36.9341 21.1572L36.9331 21.1602L31.938 32.8975C31.7974 33.2042 31.5532 33.501 31.1401 33.7764C30.7414 34.0422 30.3686 34.1494 30.0005 34.1494H14.5835V14.251L25.0005 3.83398L26.1997 5.0332ZM8.75049 14.9834V34.1494H4.5835V14.9834H8.75049Z",
    fill: "#B2E1B6",
    stroke: "#189F3F",
    strokeWidth: 2.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSatisfied);
export default __webpack_public_path__ + "static/media/Satisfied.0002f2e97bd063dc65d7988b52d5f647.svg";
export { ForwardRef as ReactComponent };